import React from "react";
import css from "./cookie-pop.module.scss";
import { hasGoldenGateBridge } from "../utils/goldengatebridge";

function isCookiePolicyAccepted() {
  return !window.localStorage.getItem("cookie-policy");
}

function Pop(props) {
  const [show, setShow] = React.useState(false);

  const styles = props.bottom
    ? {
        bottom: "0",
        top: "auto",
        boxShadow: "0 2px 6px 0px rgba(0, 0, 0, 0.5)"
      }
    : { top: "0" };
  React.useEffect(function() {
    if (hasGoldenGateBridge()) {
      setShow(false);
    } else {
      setShow(isCookiePolicyAccepted());
    }
  }, []);

  React.useEffect(() => {
    if (typeof props.onChange === "function") {
      props.onChange(show);
    }
  }, [props, show]);

  const clickHandler = React.useCallback(() => {
    setShow(false);
    window.localStorage.setItem("cookie-policy", "accepted");
  }, [setShow]);

  return show ? (
    <div>
      <div className={css["cookie-popup"]} style={styles}>
        <div data-testid="cookie-popup" className={css["cookie-content"]}>
          This is a content discovery site where you can browse content of your
          interest. We use cookies to customize our site and serve you better.
          By using our site you agree that you are above 18 years of age and
          accept the{" "}
          <a href="https://www.glance.com/eula/">End User License Agreement</a>{" "}
          and <a href="https://www.glance.com/cookie-policy/">Cookie Policy.</a>
        </div>
        {!props.disableOkBtn ? (
          <div className={css["cookie-btn-ctn"]}>
            <button className={css["cookie-btn"]} onClick={clickHandler}>
              OK
            </button>
          </div>
        ) : null}
      </div>
    </div>
  ) : null;
}

export default Pop;
